/**
 * ? @description : Navigation Bar Component
 */

// Dependencies
import React, { Fragment, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";


// Assets
import ltelogo from ".././../assets/logov1.svg";
// import notifications from ".././../assets/notifications_white_24dp.svg";

// MUI Icons
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import GroupIcon from "@mui/icons-material/Group";

// Redux Component
import { resetUser } from "../redux/features/userSlice";

// CSS
import "./../../css/Common.css";
import { NotificationModalReuse } from "./Modals/NotificationModalReuse";
import { MessageModalReuse } from "./Modals/MessageModalReuse";
import { Category, ChevronRightSharp, ExpandMoreSharp, Insights, School, Telegram } from "@mui/icons-material";
import FolderIcon from '@mui/icons-material/Folder';
import { AnnouncementModal } from "./Modals/AnnouncementModal";
import { resetTemplate } from "../redux/features/templateSlice";
import { resetSnackbar } from "../redux/features/appSlice";

function NavBar() {
  // * Redux Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // * Username
  var username = sessionStorage.getItem("first_name");
  var role = sessionStorage.getItem("role");
  const [ preferencesOpen, setPreferencesOpen ] = useState(false);
  const preferenceOpenStyle = {
    display: "block",
    // transition: "all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s",
    height: "auto",
    zIndex:1,
  }

  const preferenceCloseStyle = {
    display: "none"
  }


  // * User Logout Function
  const logoutUser = () => {

    sessionStorage.clear();
    localStorage.clear();

    dispatch(
      resetUser()
    );
    dispatch(
      resetTemplate()
    );
    dispatch(
      resetSnackbar()
    );

    navigate("/login");

    window.location.reload();
  };

  return (
    <Fragment>
      {role === "admin" ? (
        <div className="navbar-notify">
          {/* Navigation Bar */}
          <nav className="navbar navbar-expand-lg navbar-dark navbar-primary">
            <div className="container-fluid">
              {/* Logo */}
              <div className="navbar-brand">
                <img className="ltelogo" src={ltelogo} alt="Logo" />
              </div>

              {/* Navigation Links */}
              <button
                type="button"
                className="navbar-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto mb-5 mb-lg-0 navbar_navlink">
                  <li className="nav-item" style={{display: "flex"}}>
                    <NavLink
                      exact="true"
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      aria-current="page"
                      to="/dashboard"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:  "center",
                        gap: 10
                      }}
                    >
                      <Insights/>
                      DASHBOARD
                    </NavLink>
                  </li>

                  <li className="nav-item" style={{display: "flex"}}>
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/callouts"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:  "center",
                        gap: 10
                      }}
                    >
                      <Telegram/>
                      CALLOUTS
                    </NavLink>
                  </li>

                  <li className="nav-item" style={{display: "flex"}}>
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/lte-session"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:  "center",
                        gap: 10
                      }}
                    >
                      <School/>
                      TEACHER TRAINING
                    </NavLink>
                  </li>

                  <li className="nav-item" style={{display: "flex"}}>
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/category"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:  "center",
                        gap: 10
                      }}
                    >
                      <Category></Category>
                      TEACHER STUDENT ALLOCATIONS
                    </NavLink>
                  </li>
                  <li className="nav-item" style={{display: "flex"}}>
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/lte-session-student"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent:  "center",
                        gap: 10
                      }}
                    >
                      <FolderIcon></FolderIcon>
                      LTE SESSION
                    </NavLink>
                  </li>
                </ul>

                <form style={{ display: "flex", alignItems: "center" }}>

                  {/*Announcement panel*/}
                  <AnnouncementModal />

                  {/* Message panel */}
                  <MessageModalReuse />

                  {/* Notification Panel */}
                  <NotificationModalReuse 
                    getNotificationUrl="notification/unread/adminnotif"
                    clearNotificationUrl="notification/update/admin/read_status"
                  />

                  {/* Username & Dropdown */}
                  <div className="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="btn btn-outline-light dropdown-toggle"
                    >
                      Hi, {username !== "" ? username : "user"}
                    </button>
                    <ul
                      className="dropdown-menu override-dropdown-left"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li onClick={(e) => {
                        e.stopPropagation()
                        setPreferencesOpen(!preferencesOpen);
                      }}><h6>Preferences <span>{preferencesOpen ? <ExpandMoreSharp/> : <ChevronRightSharp/>}</span></h6></li>
                      <li style={preferencesOpen ? preferenceOpenStyle : preferenceCloseStyle} onClick={() => navigate("/profile")}><h6>Profile</h6></li>
                      <li style={preferencesOpen ? preferenceOpenStyle : preferenceCloseStyle} onClick={() => navigate("/admin/signup")}>
                        <h6>Create Admin/Spoc</h6>
                      </li>
                      <li style={preferencesOpen ? preferenceOpenStyle : preferenceCloseStyle} onClick={() => navigate("/admin/list")}>
                        <h6>View Admin/Spoc</h6>
                      </li>
                      <li style={preferencesOpen ? preferenceOpenStyle : preferenceCloseStyle} onClick={() => navigate("/password/change")}>
                        <h6>Change Password</h6>
                      </li>
                      <li style={preferencesOpen ? preferenceOpenStyle : preferenceCloseStyle} onClick={() => navigate("/templates")}>
                        <h6>Configure templates</h6>
                      </li>
                      <li onClick={() => navigate("/faq")}><h6>FAQ</h6></li>
                      <li onClick={logoutUser}><h6>Logout</h6></li>
                    </ul>
                  </div>
                </form>
              </div>
            </div>
          </nav>

          {/* Router */}
          <Outlet />
        </div>
      ) : (
        <div className="navbar-notify">
          {/* Navigation Bar */}
          <nav className="navbar navbar-expand-lg navbar-dark navbar-primary">
            <div className="container-fluid">
              {/* Logo */}
              <div className="navbar-brand">
                <img className="ltelogo" src={ltelogo} alt="Logo" />
              </div>

              {/* Navigation Links */}
              <button
                type="button"
                className="navbar-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto mb-5 mb-lg-0 navbar_navlink">
                  <li className="nav-item">
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/spoc/training"
                    >
                      <IconButton>
                        <AssignmentIndIcon
                          fontSize="medium"
                          sx={{ color: "white" }}
                        />
                      </IconButton>
                      TRAINING
                    </NavLink>
                  </li>

                  <li className="nav-item">
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/spoc/mapped"
                    >
                      <IconButton>
                        <GroupIcon fontSize="medium" sx={{ color: "white" }} />
                      </IconButton>
                      MAPPED
                    </NavLink>
                  </li>

                  {/* <li className="nav-item">
                    <NavLink
                      activeclassname="active"
                      className="nav-link custom-text-color"
                      to="/spoc/mapped"
                    >
                      <IconButton>
                        <CampaignSharp fontSize="medium" sx={{ color: "white" }} />
                      </IconButton>
                      ANNOUNCEMENT
                    </NavLink>
                  </li> */}
                </ul>

                <form style={{ display: "flex", alignItems: "center" }}>

                  {/*Announcement panel*/}
                  <AnnouncementModal />

                  {/* Message panel */}
                  <MessageModalReuse />

                  {/* Notification Panel */}
                  <NotificationModalReuse 
                    getNotificationUrl="notification/unread/spocnotif"
                    clearNotificationUrl="notification/update/spoc/read_status"
                  />

                  {/* Username & Dropdown */}
                  <div className="dropdown">
                    <button
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="btn btn-outline-light dropdown-toggle"
                    >
                      Hi, {username !== "" ? username : ""}
                    </button>
                    <ul
                      className="dropdown-menu override-dropdown-left"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {/* <li onClick={() => navigate("/profile")}>Profile</li>
                    <li onClick={() => navigate("/admin/signup")}>
                      Create Admin
                    </li>
                    <li onClick={() => navigate("/password/change")}>
                      Change Password
                    </li>
                    <li onClick={() => navigate("/faq")}>FAQ</li> */}
                      <li onClick={logoutUser}>Logout</li>
                    </ul>
                  </div>
                </form>
              </div>
            </div>
          </nav>

          {/* Router */}
          <Outlet />
        </div>
      )}
    </Fragment>
  );
}

export default NavBar;
